<template>
  <div :class="bem('')">
    <div :class="bem('titles')">
      <span v-if="props.number" :class="bem('number')">{{ props.number }}</span>
      <VisionHeading tag="h6" size="h5" :class="bem('title')">{{ props.title }}</VisionHeading>
      <ToolTip v-if="props.tooltip" :content="props.tooltip" />
    </div>
    <div :class="bem('value')">
      {{ props.value }}
    </div>
  </div>
</template>

<script setup lang="ts">
const bem = useBEM('ProductSpecificationItem')

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  value: {
    type: String,
    required: true
  },
  tooltip: {
    type: String,
    required: false,
    default: ''
  },
  number: {
    type: String,
    required: false,
    default: ''
  }
})
</script>

<style lang="postcss">
.ProductSpecificationItem {
  @apply grid grid-cols-2 gap-4 w-full items-center;
}

.ProductSpecificationItem__titles {
  @apply flex gap-1 items-center;
}

.ProductSpecificationItem__title {
  @apply text-grey-500;
}

.ProductSpecificationItem__value, .ProductSpecificationItem__number {
  @apply font-fragment-mono text-xs;
}

.ProductSpecificationItem__number {
  @apply mr-1;
}
</style>